import { SettingsUserGroupsUserGroupFullDto } from '../interfaces';
import { generateMock } from '../../../lib';
import { mockUserGroupFullFields } from './userGroupMockFields';

export const getSettingsUserGroupsMockUserGroup = () => {
    return generateMock<SettingsUserGroupsUserGroupFullDto>(mockUserGroupFullFields);
};
